import { Close } from "@mui/icons-material";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
} from "@mui/material";
import { styled } from "@mui/system";
import dayjs from "dayjs";
import { displayDateFormat } from "../../../../constants";
import {
    IWithClassName,
    IWithThemeProps,
} from "../../../../theme/default.theme";
import { IDialogBox } from "../../interface/historical-option";

const DialogBox = ({
    open,
    date,
    handleClose,
    className,
}: IDialogBox & IWithClassName) => (
    <Dialog open={open} onClose={handleClose} className={className}>
        <DialogTitle>{dayjs(date).format(displayDateFormat)}</DialogTitle>
        <IconButton aria-label="close" onClick={handleClose}>
            <Close />
        </IconButton>
        <DialogContent dividers>
            <DialogContentText>
                The date you selected is already included in the snapshot table.
                Please try another date.
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleClose} autoFocus>
                Okay
            </Button>
        </DialogActions>
    </Dialog>
);

export default styled(DialogBox)(({ theme }: IWithThemeProps) => ({
    ".MuiIconButton-root": {
        position: "absolute",
        right: 8,
        top: 8,
    },
    ".MuiSvgIcon-root": {
        color: theme?.palette.grey[500],
    },
    ".MuiButtonBase-root": {
        textTransform: "capitalize",
    },
}));
